import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import BranchSelect from 'component/branch/BranchSelect'
import Checkbox from '../Checkbox/newCheckbox'
import NewDateIntervalInput from 'component/DateIntervalInput/NewDateIntevalInput'
import DateMonthYearInput from 'component/DateMonthYearInput/DateMonthYearInput'
import HierarchySelect from 'component/hierarchy/HierarchySelectNew'
import HierarchySubtypeSelect from 'component/hierarchy/HierarchySubtypeSelectNew'
import PropTypes from 'prop-types'
import RegionBranchMultipleSelect from 'component/branch/RegionBranchMultipleSelectNew'
import Select from '../Select/Select'
import TextField from '../TextField'
import RadioGroup from '../RadioGroup'
import RadioButton from '../Radio'
import 'images/select-arrow.svg'
import { isEmpty} from 'utils/validations'
import _ from 'lodash'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import LdapInput from '../mobileUpdatesNew/LdapInput'

class Form extends React.Component {

  constructor(props) {
    super(props)
    this.myRef = React.createRef()
  }
  

  state = {
    formData: {},
    btnDisabled: false,
    branchs: [],
    branch: false,
    sections: [],
    subtypes:   [],
    subSections: [],
    cdLm: '',
    position: '',
    clearSelect : true,
    status: false,
    prevFormData: {},
    shouldResetFilters: false,
    depositType: [],
    missionsSelectBranchs: [],
    dsLdap: [],
    depositTypeOptions: [],
  }

  static defaultProp = {
    cleanFilters: false
  }

  getDepositOptionsParams = (values) => {
    const {user} = this.props
    return new Api(user.dsToken)
    .get(API_URL.PARAMETER_GET, values, "")
    .then(resp => {
      const depositTypes = resp.data.split(",").map((item) => ({label: item, value: item}))
      this.setState({depositTypeOptions: depositTypes})
    })
  }


  backPrevValues(values, type) {
    const event = {
      target : {
        value: values
      },
      value: values
    }


    this.updateValue(event,type)
  }

  componentDidUpdate(prevProps) {

    const {fields } = this.props
    if(prevProps.showFilter !== this.props.showFilter && this.props.showFilter === false) {
      const {prevFormData, shouldResetFilters} = this.state

      if(!isEmpty(prevFormData) && shouldResetFilters) {

      const newformData = {...prevFormData}

      const radioGroup = fields.filter(filter => filter.type === "radio_group")

      const fieldsFiltered = fields.filter(f => f.type !== 'date_range' && f.type !== "new_ds_ldap" &&  f.type !== "radio_group" && f.type !== 'branchs' && f.type !== 'sections' && f.name !== "depositType")
      
      fieldsFiltered.forEach(field => this.backPrevValues(newformData[field.name], field))
        this.updateValue({target : { value : newformData.totalBranchs}}, {type: "branchs", name: "branchIdList"})
        this.updateValue(newformData.totalSections, fields.filter(f => f.type === "sections")[0])
        const depositTypeField = fields.find(f => f.name === "depositType" )
        const ldapField = fields.find(f => f.type === "new_ds_ldap")

        if (ldapField) {
          this.updateValue(newformData.dsLdaps, ldapField)
        }
        if(depositTypeField) {
          const prevDeposit  = (newformData.depositType || []) .map(d => ({label:d , value: d}))
          this.updateValue(prevDeposit, depositTypeField)
        }
        this.setState({shouldResetFilters: false})
        const currentFormData = {...this.state.formData}
        radioGroup.forEach(radio => {
          if(typeof(radio.onChangeRadio) === 'function') {
            radio.onChangeRadio(prevFormData[radio.name])
          }
          currentFormData[radio.name] = prevFormData[radio.name]
        })
        this.setState({formData: currentFormData})
      }
    }

  }

  getParameter(values) {
    const {user} = this.props
    return new Api(user.dsToken)
    .get(API_URL.PARAMETER_GET, values)
    .then(resp => this.setState({missionsSelectBranchs: resp.data.split(",")}))
  }

  componentDidMount() {
    const formInit = {}
    const params = {
      dsKey: 'missions.select.branchs',
      nuParameter: 1
    }
    this.getParameter(params)

    const depositTypeParams = {
      dsKey: 'irc.supply.deposit.type',
      nuParameter: 1
    }

    this.getDepositOptionsParams(depositTypeParams)
    const { isUserMatriz, user } = this.props

    for (const field of this.props.fields || []) {
      switch (field.type) {
        case 'select_multiple':
        case 'date_range':
        case 'date_month_year':
        case 'sections':
        case 'radio_group':
        case 'subtypes':
          formInit[field.name] = field.initial ? field.initial : []
          break
        case 'hour_range':
          formInit[field.name] = field.initial ? field.initial : ['', '']
          break
        case 'branchs':
          formInit[field.name] = !isUserMatriz ? [user.locationCode.padStart(4, '0')] : (field.initial ? field.initial : [])
          break
        case 'branchs_without_multselect':
          formInit[field.name] = !isUserMatriz ? user.locationCode.padStart(4, '0') : (field.initial ? field.initial : '')
          break
        default:
          formInit[field.name] = field.initial ? field.initial : ''
          break
      }

      if (field.type === 'branchs_without_multselect' && formInit[field.name].length > 0) {
        this.setState({ branch: formInit[field.name] })
      }

      if (field.type === 'branchs' && formInit[field.name].length > 0) {
        const branchs = []

        formInit[field.name].forEach((branch) => {
          branchs.push({ value: branch })
        })

        this.setState({ branchs })
      }

      if (['select', 'select_multiple'].indexOf(field.type) !== -1) {
        const obj = {}
        if (typeof field.options === 'function') {
          field.options((options = []) => {
            obj[`select${field.name}`] = options || []
          })
        } else {
          const options = field.options || []
          obj[`select${field.name}`] = options || []
        }
        this.setState(obj)
      }

      if (
        [
          'select_multiple',
          'date',
          'branchs',
          'branchs_without_multselect',
          'sections',
          'date_range',
          'date_month_year',
          'subtypes',
        ].indexOf(field.type) !== -1
      ) {
        const errorObj = {}

        errorObj[`field ${field.name}error`] = false
        errorObj[`field ${field.name}valid`] = false
        this.setState(errorObj)
      }
    }

    this.setState({ formData: formInit })

    this.checkBtnDisable()
  }

  formatData(dtRange) {

    if(Array.isArray(dtRange) && dtRange.length > 0) {
    const dateStart = dtRange[0].substring(0,10)
    const dateEnd = dtRange[1].substring(0,10)
    return {dateStart, dateEnd}
    }
  }

  checkSameValues()  {
    const { formData, prevFormData } = this.state
    const formDataIgnoreFields = {...formData}
    delete formDataIgnoreFields.limit
    delete formDataIgnoreFields.order
    delete formDataIgnoreFields.orderDirection
    delete formDataIgnoreFields.page
    formDataIgnoreFields.dtRange = this.formatData(formDataIgnoreFields.dtRange)

    const prevFormIgnoreFields = {...prevFormData}
    delete prevFormIgnoreFields.totalBranchs
    delete prevFormIgnoreFields.totalSections
    delete prevFormIgnoreFields.limit
    delete prevFormIgnoreFields.order
    delete prevFormIgnoreFields.orderDirection
    delete prevFormIgnoreFields.page
    prevFormIgnoreFields.dtRange = this.formatData(prevFormIgnoreFields.dtRange)


    if(_.isEqual(formDataIgnoreFields, prevFormIgnoreFields)) {

      return true
    }
  }

  checkBtnDisable() {
    const { fields } = this.props
    const { formData } = this.state
    let disabled = false
    for (const field of fields) {

      if (
        formData[field.name] &&
        formData[field.name].length &&
        field.attrs &&
        field.attrs.minLength &&
        formData[field.name] &&
        formData[field.name].length < field.attrs.minLength
      ) {

        disabled = true
      }
      if (field.required) {
        if (
          field.name !== 'reportType' &&
          (Array.isArray(formData[field.name]) &&
            formData[field.name].length === 0) ||
          (!Array.isArray(formData[field.name]) && !formData[field.name])
        ) {
          disabled = true
          if(field.name === 'reportType' && formData[field.name] === 0) {
            disabled = false
          }
          
        }

        if(field.type === 'sections') {
          const sections = formData[field.name]
          const lms = formData.dsLdaps
          if ( isEmpty(sections) && !isEmpty(lms) ) {
            disabled = false
          }
        }
        if (field.type === 'input' && field.name === 'dtYear') {
          const inputValue = parseInt(formData.dtYear, 10)
          const dtCurrentYear = new Date().getFullYear()
          if (inputValue < 2019 || inputValue > dtCurrentYear) disabled = true
        }
      }

      if (field.type === 'hour_range' && formData[field.name]) {
        if (formData[field.name][0].length !== 0 && formData[field.name][0].length !== 5) {
          disabled = true
        }

        if (formData[field.name][1].length !== 0 && formData[field.name][1].length !== 5) {
          disabled = true
        }
      }
    }

    if(this.checkSameValues())
      this.setState({ btnDisabled: true })
    else
      this.setState({ btnDisabled: disabled })
  }

  submit(isFlux = false) {
    const { onSubmit = () => { }, onSubmitFlux = () => {} } = this.props
    const {branchs,sections} = this.state

    const copyState = {...this.state.formData, totalBranchs: branchs, totalSections: sections}

    this.setState({prevFormData: copyState})
    this.setState({btnDisabled: true})
    if(!isFlux) onSubmit(this.state.formData)
    else onSubmitFlux(this.state.formData)

  }

  updateValue(e, props) {
    if(!props) return
   
    const form = this.state.formData
   
    switch (props.type) {
      case 'select_multiple':
        if(!props.name === "depositType") {
          this.setState({clearSelect: true})
        const selected = []
        if (e) {
          for (const o of e) {
            selected.push(o.value)
          }
        }

        form[props.name] = e ? [] : selected
        }
        else {
         
          const selected = []
          const array = Array.isArray(e) ? e : e.value
          if (e) {
            for (const o of array) {
              selected.push(!isEmpty(o.value) ? o.value : o)
            }
          }
        
        form[props.name] = e ? selected : []
        this.setState({depositType: e})
          
        }
        break

      case 'new_ds_ldap':
        this.setState({dsLdap: e })
        form[props.name] = e
        break;
      case 'select':
        this.setState({status: e.value})
        form[props.name] = e ? e.value : false
        break
      case 'checkbox':
        form[props.name] = e ? 1 : 0
        break
      case 'branchs':
        if(e.target.value === '') {
          this.setState({branchs: []})
          form[props.name] = []
          break
        }
        this.setState({ branchs: e.target.value })
        let branchs = []

        for (const b of e.target.value) {
          if (b.idBranches) {
            branchs.push(...b.idBranches)
          } else {
            branchs.push(b.value)
          }
        }
        branchs = branchs.filter((b, p) => branchs.indexOf(b) === p)
        form[props.name] = e ? branchs : []
        break

      case 'branchs_without_multselect':
        this.setState({ branch: e.target.value })
        form[props.name] = e ? e.target.value.value : ''
        break
      case 'sections':

        if(e.length === 0) {
          form[props.name] = e || ''
        }

        this.setState({ sections: e })
        const sections = []
        for (const s of e) {
          if (s.sectionId) {
            sections.push(s.sectionId)
          }
        }
        form[props.name] = e ? sections : ''
        break
      case 'subtypes':
        this.setState({ subtypes: e })
        form[props.name] = e || ''
        break
      case 'date_range':
        const dates = []
        if (e) {
          for (const date of e) {
            dates.push(date.format())
          }
        }
        form[props.name] = e ? dates : []
        break
      case 'date_month_year':
        form[props.name] = e || ''
        break
      case 'radio_group':
        form[props.name] = e || ''
        break
      case 'hour_range':
        form[props.name][e.index] = e ? e.target.value : ''
        break
      case 'input':
        if(props.name === 'position') this.setState({position: e.target.value})
        if(props.name === 'cdLm') this.setState({cdLm: e.target.value})
        form[props.name] = e.target.value ? e.target.value : ''
        break
      default:
        
        form[props.name] = e ? e.target.value : ''
        break
    }

    const event = {
      ...e,
    }

    this.setState({ formData: form }, () => {


      if (typeof props.onChangeValue === 'function') {
        props.onChangeValue(event, this.setValueToField)
      }

      if(typeof props.onChangeRadio === 'function') {
        props.onChangeRadio(e)
      }
      setTimeout(() => this.checkBtnDisable(), 150)
    })
  }

  setValueToField = (field, value) => {
    if (this.state.hasOwnProperty(field)) {
      this.setState({
        [field]: value,
      })
    }

    if (this.state.formData.hasOwnProperty(field)) {
      this.setState({
        formData: {
          ...this.state.formData,
          [field]: value,
        },
      })
    }
  }

  renderOnlyFilter() {
    const { btnDisabled } = this.state
    const { translate, buttonCompleteWidth, disableButton } = this.props
    return <div className='bottom'>

            <button
              className={`btn btn-primary ${buttonCompleteWidth && 'complete-width'
                }`}
              disabled={btnDisabled || disableButton}
              onClick={() => {
                this.setState(this.submit())

              }}
            >
              {translate('commonReport.filter')}
            </button>
          </div>
  }

  resetFilters() {
    const {fields} = this.props
    this.cleanFilterCallback(fields)

  }

  cleanFilterCallback(fields) {
    const {user, isUserMatriz} = this.props
    const shouldCleanBranch = isUserMatriz || user.locationCode === "999" || this.state.missionsSelectBranchs.includes(user.title)
    const noResetTypes = ["date_range"]
    if (!shouldCleanBranch) {
      noResetTypes.push("branchs")
    }
    const noResetDate = fields.filter(f => !noResetTypes.includes(f.type))


    noResetDate.forEach(field => {

      if(typeof(field.onChangeRadio) === 'function' ) {
        field.onChangeRadio(4)
      }
      if (field.type === 'input' || field.type === 'branchs')
        this.updateValue({target: {value: ''}, name: field.type}, field)

      else if(field.type === "radio_group") {
        const form = {...this.state.formData}
        const lastOption = field.options[field.options.length - 1].value
        form[field.name] = lastOption
        this.setState({formData: form})

      }

      else {

        this.updateValue([], field)
      }
      delete this.state.formData[field.name]
      this.setState({shouldResetFilters: true})
    })


  }

  renderWithCleanFieldFilter() {
    const { btnDisabled } = this.state


    const { translate, buttonCompleteWidth, disableButton } = this.props
    return <div className='flex flex-row gap-filters padding-filters'>

              <button
                className={`btn btn-danger-outline ${buttonCompleteWidth} full-w`}
                onClick={() => this.resetFilters()}
              >
                {translate('suggestions.cleanFilters')}
              </button>


              <button
                      className={`btn btn-primary ${buttonCompleteWidth } full-w`}
                      disabled={btnDisabled || disableButton }
                      onClick={() => this.submit()}
                    >
                      {translate('commonReport.filter')}
                </button>

            </div>
  }

  buildField(props) {

    const { translate, user, isUserMatriz } = this.props
    const { branchs, branch, formData,cdLm , position} = this.state

    let field

    switch (props.type) {
      case 'select':
      case 'select_multiple':

        field = this.buildSelect(props)
        break

      case 'checkbox':
        field = (
          <Checkbox
            name={props.name}
            label={props.label}
            onChange={(e) => {
              this.updateValue(e, props)
            }}
            checked={props.initial}
            {...props.attrs}
          />
        )
        break

      case 'branchs':
        field = (
          <RegionBranchMultipleSelect
            onChange={(e) => this.updateValue(e, props)}
            placeholder={props.help_text ? props.help_text : ''}
            label={props.label}
            name={'branchs'}
            translate={translate}
            user={user}
            value={branchs}
            required={props.required}
            disabled={!isUserMatriz}
          />
        )
        break

      case 'branchs_without_multselect':
        field = (
          <BranchSelect
            onChange={(e) => this.updateValue(e, props)}
            placeholder={props.help_text ? props.help_text : ''}
            label={props.label}
            name={'branch'}
            translate={translate}
            user={user}
            value={branch}
            required={props.required}
            disabled={!isUserMatriz}
            {...props.attrs}
          />
        )
        break

      case 'sections':
        const { sections } = this.state
        field = (
          <HierarchySelect
            onChange={(e) => this.updateValue(e, props)}
            placeholder={props.help_text ? props.help_text : ''}
            label={props.label}
            required={props.required}
            translate={translate}
            user={user}
            value={sections}
            query={{ level: 2 }}
            name={props.name}
            isMulti
            {...props.attrs}
          />
        )
        break

      case 'subtypes':
        const {subtypes} = this.state

        field = (
          <HierarchySubtypeSelect
            user={user}
            placeholder={props.help_text ? props.help_text : ''}
            isMulti
            translate={translate}
            label={props.label}
            required={props.required}
            query={ props.query }
            noOptions={
              !props.query ||
              !props.query.sectionIdList ||
              props.query.sectionIdList.length === 0
            }
            onChange={(e) => {
              this.updateValue(e, props)
            }}
            value={subtypes}
            name={props.name}
            {...props.attrs}
          />
        )
        break

      case 'date_range':
        field = (
          <NewDateIntervalInput
            t={translate}
            user={user}
            label={props.label}
            mainRef={this.myRef}
            required={props.required}
            showHelperArea={props.showHelperArea}
            onChange={(e) => {
              this.updateValue(e, props)
            }}
            options={props.options}
            maxLimitDay={user.isLdapInManager ? false : parseInt(user.reportLimitDaysFilter, 10)}
            {...props.attrs}
          />
        )
        break

      case 'hour_range':
        field = (
          <div className='flex flex-row'>
            <div className='margih-right'>
              <TextField
                type='text'
                required={props.required}
                label={translate('query.logs.hourStart')}
                name={props.name}
                onChange={(e) => {
                  this.updateValue({ ...e, index: 0 }, props)
                }}
                value={props.initial ? props.initial[0] : ''}
                placeholder={props.help_text}
                fill
                mask='99:99'
                {...props.attrs}
              />
            </div>
            <div className='margin-left'>
              <TextField
                type='text'
                required={props.required}
                label={translate('query.logs.hourEnd')}
                name={props.name}
                onChange={(e) => {
                  this.updateValue({ ...e, index: 1 }, props)
                }}
                value={props.initial ? props.initial[1] : ''}
                placeholder={props.help_text}
                fill
                mask='99:99'
                validateValue={() => false}
                {...props.attrs}
              />
            </div>
          </div>
        )
        break

      case 'date_month_year':
        field = (
          <DateMonthYearInput
            t={translate}
            label={props.label}
            required={props.required}
            placeholder={props.help_text}
            onChange={(e) => {
              this.updateValue(e, props)
            }}
            {...props.attrs}
          />
        )
        break

      default:
        field = (
          <TextField
            type='text'
            required={props.required}
            label={props.label}
            name={props.name}
            onChange={(e) => {
              this.updateValue(e, props)
            }}
            value={props.name === "position" ? position : cdLm}
            placeholder={props.help_text}
            fill
            {...props.attrs}
          />
        )
        break

        case 'new_ds_ldap':
          field = (<LdapInput
                isLm={props.isLm}
                customTitle={<span style={{fontWeight: 600, fontStyle: 'normal',}}>{"LM"} - <i style={(props.attrs?.disabled || false) ? {color:"#b7b2b7",fontWeight: 600,fontStyle:"italic"} : {fontWeight: 600,fontStyle:"italic"}} >{translate('optional')}</i> </span> }
                values={this.state.dsLdap}
                disabled={props.attrs?.disabled}
                onChange={(value) => {
                  !(this.state.dsLdap || []).some((dsLdap) => dsLdap === value) &&
                    this.updateValue(this.state.dsLdap ? [...this.state.dsLdap, value] : [value], props)
  
                }}
                removeOption={(index) => {
                  const copy = Array.from(this.state.dsLdap)
                  copy.splice(index, 1)
                  this.updateValue(copy, props)
                }}
                translate={translate}
              />)
              break

      case 'radio_group':
        field = (
          <Fragment>
            {props.title && (
              <div className='radio-group-title-container'> <span className='radio-group-title'>{props.title}</span> </div>
            )}
            <RadioGroup

              className={
                props.title && 'margin-top-small margin-bottom-almost-double'
              }
            >
              {props.options.map((val, i) => (
                <RadioButton
                  key={i}
                  checked={formData[props.name] === val.value}
                  defaultChecked={!!val.checked}
                  onClick={() => this.updateValue(val.value, props)}
                  name={`radioGroup.${props.name}`}
                  label={val.label}
                />
              ))}
            </RadioGroup>
          </Fragment>
        )
    }

    return field
  }

  

  buildSelect(props) {
    
    const { translate } = this.props
    const options = this.state[`select${props.name}`] || []
    const {status, depositType} = this.state
    
    return (
      <Select
        value={props.name === "depositType" ? depositType : options[status]  || false }
        isMulti={props.type === 'select_multiple'}
        fill
        selectAll
        groupOptions={!props.noGroup}
        required={props.required}
        name={props.name}
        options={props.isDepositTypesSelect ? this.state.depositTypeOptions : options}
        translate={translate}
        label={props.label}
        placeholder={props.help_text}
        onChange={(e) => {
          this.updateValue(e, props)
        }}
        {...props.attrs}
      />
    )
  }

  render() {

    return (
      <>
        <form
          onSubmit={(e) => e.preventDefault()}
          id='report-form'
          noValidate
          autoComplete='off'
        >
          {this.props.fields.map((field, i) => (
            <div key={i} className={field.half ? 'col col-half' : 'col'}>
              {this.buildField(field)}
            </div>
          ))}

            {this.props.cleanFilters ?  this.renderWithCleanFieldFilter() : this.renderOnlyFilter()}
        </form>
      </>
    )
  }
}

Form.propTypes = {
  fields: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  user: PropTypes.object,
  translate: PropTypes.func.isRequired,
  buttonCompleteWidth: PropTypes.bool,
  disableButton: PropTypes.bool,
  isUserMatriz: PropTypes.bool,
  cleanFilters: PropTypes.bool,
  showFilter: PropTypes.bool,
  onSubmitFlux: PropTypes.func,
}

const mapStateToProps = ({ auth }) => ({
  isUserMatriz: auth.isUserMatriz,
  user: auth.user
})

export default connect(mapStateToProps)(Form)

export { Form }
